import type { SearchSelectOption } from "../SearchSelect/SearchSelect";

const normalize = (name: string) => name.trim().toLowerCase();

/**
 * Whether typed text may be offered as a new tag: not blank, no comma (tags
 * are never split on commas), and not already selected or loaded, ignoring
 * case and surrounding spaces.
 */
export const isNewTagName = (
  input: string,
  selected: readonly SearchSelectOption[],
  options: readonly SearchSelectOption[]
): boolean => {
  const name = normalize(input);
  if (!name || name.includes(",")) return false;
  return ![...selected, ...options].some(
    (option) => normalize(option.label) === name
  );
};
